import { useState, useEffect, useRef } from "react";
import MainLayout from "../components/MainLayout";
import GridPage from "../components/GridPage";
import { checkInHeader, checkInHeader1 } from "../components/HeaderAttribute";
import MainPopup from "../popup-containers/MainPopup";
import PopUpScreenTitle from "../components/PopUpScreenTitle";
import PopUpButtons from "../components/PopUpButtons";
import Checkinpopup from "../popup-containers/CheckInPopup";
import { BindAPI, BindPostAPI } from "../services/APIConnection";
import Loader from "../ReusableComponents/Loader";
import { mainTable } from "../css/Common";
const CheckIn = () => {
  var clientId = sessionStorage.getItem("MstClientId");
  const [villatypedropdown, setvillatypedropdown] = useState([]);
  const childRef = useRef();
  const [roomtype, setroomtype] = useState([]);
  const [paymentType, setPaymentType] = useState([]);
  const [bookedData, setBookedData] = useState([]);
  const [bookedData1, setBookedData1] = useState([]);
  const [bindBookingData, setBindBookingData] = useState([]);
  const [bindBookingChildData, setBindBookingChildData] = useState([]);
  const [bindGuestChildData, setBindGuestChildData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [confirm, setConfirmRecord] = useState("");
  const [confirm1, setConfirmRecord1] = useState("");
  const [confirm2, setConfirmRecord2] = useState([]);
  const [confirm3, setConfirmRecord3] = useState([]);
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false);
  const [rowIndex, setRowIndex] = useState(null);
  const [viewPopUp, setViewPopUp] = useState(false);
  const [popupOpen, setPopupOpen] = useState(false);
  const [flag, setFlag] = useState("");
  var clientId = sessionStorage.getItem("MstClientId");
  useEffect(() => {
    BindGetEnquiryValues();
  }, []);

  const BindGetEnquiryValues = async () => {
    const data = {
      mstClientId: clientId,
    };
    const response = await BindPostAPI(data, "Enquiry/BindGetEnquiryValues");
    if (response && response.data) {
      const RoomTypeid = response.data.Table7.map((item) => ({
        value: item.MstRoomtypeId,
        label: item.RoomType,
      }));
      setroomtype(RoomTypeid);
      const PaymentTypeId = response.data.Table10.map((item) => ({
        value: item.MstPaymentTypeId,
        label: item.PaymentTypeId,
      }));
      setPaymentType(PaymentTypeId);
      //setTableData(RoomTypeid.length)
    } else {
      setBindBookingData([]);
    }
  };
  useEffect(() => {
    BindEnquiryrData();
  }, []);
  const clear = () => {
    BindGetEnquiryValues();
    BindEnquiryrData();
  };
  const BindEnquiryrData = async () => {
    const data = {
      mstClientId: clientId,
    };
    setIsLoading(true);
    const response = await BindPostAPI(data, "Enquiry/BindEnquiry");
    console.log("API Response BindEnquiry:", response);
    if (response && response.data) {
      setBindBookingData(response.data.Table);
      setBindBookingChildData(response.data.Table1);
      setBindGuestChildData(response.data.Table2);
      const filteredRecords = response.data.Table.filter(
        (item) =>
          item.MstEnquiryStatusId == 4 &&
          item.BookingDeletedBy == null
      );

      setBookedData(filteredRecords);
      console.log(filteredRecords, "Filtered records")
      const filteredRecords1 = response.data.Table.filter(
        (item) => item.MstEnquiryStatusId == 6
      );

      setBookedData1(filteredRecords1);
    } else {
      setBindBookingData([]);
      setBindBookingChildData([]);
    }
    setIsLoading(false);
  };
  const handleClick = () => {
    childRef.current.childFunction(); // Calling child function
  };
  const handleSubmit = () => { };
  const cancel = () => {
    BindEnquiryrData();
    if (
      childRef.current &&
      typeof childRef.current.childCancelFunction === "function"
    ) {
      childRef.current.childCancelFunction(); // ✅ Safe call
    } else {
      console.error("childCancelFunction is not defined");
    }
    setPopupOpen(false);

    setViewPopUp(false);
    setFlag("");
  };

  const toYMD = (dateStr) => {
    // dateStr format: "DD-MM-YYYY"
    const [dd, mm, yyyy] = dateStr.split("-");
    return `${yyyy}-${mm}-${dd}`;
  };
  const onConfirmBooking = async (rowIndex, flag) => {
    setRowIndex(rowIndex);
    setPopupOpen(true);
    setFlag("");
    const value = bookedData[rowIndex];
    const txnEnquiryId = value?.TxnEnquiryId;

    setConfirmRecord(value);

    const drpdetailsData = [villatypedropdown, paymentType];
    setConfirmRecord1(drpdetailsData);

    // Step 1: Filter child records for this enquiry
    const filtered = Object.values(bindBookingChildData).filter(
      (item) => String(item.TxnEnquiryId) === String(txnEnquiryId)
    );

    // Step 2: Grouping to get unique RoomType
    const groupedTable = {};
    filtered.forEach((item) => {
      const key = item.MstRoomId;
      if (!groupedTable[key]) {
        groupedTable[key] = item;
      }
    });
    // Step 3: Create base roomTableDetailsData with everything from enquiry child
    const roomTableDetailsData = Object.values(groupedTable)
      .filter((item) => item.BookingNoOfRequiredRooms > 0)
      .map((item) => ({
        TxnEnquiryChildId: item.TxnEnquiryChildId,
        RoomTypeId: item.MstRoomTypeId,
        MstRoomId: item.MstRoomId,
        RoomType: item.RoomType,
        RoomId: item.RoomId,
        RoomName: item.RoomName,
        AvailableRoomsId: "", // will be fetched
        AvailableRoomsName: "",
        AvailableRooms: item.NoOfAvailableRooms, // will be fetched
        Numberofrooms: item.BookingNoOfRequiredRooms,
        numberofadults: item.BookingNoOfAdults,
        numberofchildren: item.BookingNoOfChildren,
        Tariff: item.BookingBasicTariff,
        specialtariff: item.BookingSpecialTariff,
        amount: item.BookingAmount,
        Photo: item.Photo,
        Size: item.Size,
        MaxOccupancy: item.MaxOccupancy,
        Bedrooms: item.Bedrooms,
        Balcony: item.Balcony,
        LivingRoom: item.LivingRoom,
        SpaceDetails: item.SpaceDetails,
        AmenitiesDetails: item.AmenitiesDetails,
        SelectedRoomIds: item.SelectedRoomIds,
        total: item.BookingSpecialTariff,
      }));

    // Step 4: Show popup now, will fill data next
    // handleDeleteRow(0);
    setConfirmRecord2(roomTableDetailsData); // temporary without availableRooms
    setPopupOpen(true);

    // Step 5: Add AvailableRoomsId and AvailableRooms to each row
    const fromDate = toYMD(value?.BookFrom); // "2025-08-01"; // or use dynamic: toYMD(value.BookFrom)
    const toDate = toYMD(value?.BookTo); //"2025-08-05"; // or use dynamic: toYMD(value.BookTo)

    for (let i = 0; i < roomTableDetailsData.length; i++) {
      const row = roomTableDetailsData[i];
      if (!row.RoomTypeId) continue;

      try {
        const postData = {
          mstRoomTypeId: row.RoomTypeId,
          fromDate: fromDate,
          toDate: toDate,
          mstClientId: clientId,
        };

        const response = await BindPostAPI(
          postData,
          "Enquiry/BindGetRoomDetails"
        );
        const apiRow = response?.data?.Table?.[0];

        if (apiRow) {
          row.AvailableRoomsId = apiRow.AvailableRoomsId ?? "";
          row.AvailableRooms = apiRow.AvailableRooms ?? 0;
          row.AvailableRoomsName = apiRow.AvailableRoomsName ?? "";
        } else {
          row.AvailableRoomsId = "";
          row.AvailableRooms = 0;
        }
      } catch (err) {
        console.error(`RoomTypeId ${row.RoomTypeId} failed:`, err);
        row.AvailableRoomsId = "";
        row.AvailableRooms = 0;
      }
    }

    // Step 6: Push final tableData with AvailableRooms
    setTableData([...roomTableDetailsData]);
    console.log(
      "✅ Final roomTableDetailsData with AvailableRoomsId:",
      roomTableDetailsData
    );
  };
  const handleEdit = async (rowIndex, flag) => {
    setFlag(flag);
    const value = bookedData1[rowIndex];
    const txnEnquiryId = value.TxnEnquiryId;
    setViewPopUp(true);
    const updatedValue = {
      ...value, // copy all existing fields
      TotalAmount: value.CheckInTotalAmount,
      ReceivedAmount: value.CheckInReceivedAmount,
      BalanceAmount: value.CheckInBalanceAmount,
      PaymentType: value.CheckInPaymentType,
      PaymentRefNumber: value.CheckInPaymentReferenceNumber,
      ShowImage: value.CheckInPaymentReference,
    };
    const drpdetailsData = [villatypedropdown, paymentType];
    setConfirmRecord1(drpdetailsData);

    // Step 1: Filter child records for this enquiry
    const filtered = Object.values(bindBookingChildData).filter(
      (item) => String(item.TxnEnquiryId) === String(txnEnquiryId)
    );

    // Step 2: Grouping to get unique RoomType
    const groupedTable = {};
    filtered.forEach((item) => {
      const key = item.MstRoomId;
      if (!groupedTable[key]) {
        groupedTable[key] = item;
      }
    });
    // Step 3: Create base roomTableDetailsData with everything from enquiry child
    const roomTableDetailsData = Object.values(groupedTable)
      .filter((item) => item.CheckInNoOfRequiredRooms > 0)
      .map((item) => ({
        TxnEnquiryChildId: item.TxnEnquiryChildId,
        RoomTypeId: item.MstRoomTypeId,
        MstRoomId: item.MstRoomId,
        RoomType: item.RoomType,
        RoomId: item.RoomId,
        RoomName: item.RoomName,
        AvailableRoomsName: "",
        AvailableRoomsId: "", // will be fetched
        AvailableRooms: item.CheckInNoOfAvailableRooms, // will be fetched
        Numberofrooms: item.CheckInNoOfRequiredRooms,
        numberofadults: item.CheckInNoOfAdults,
        numberofchildren: item.CheckInNoOfChildren,
        Tariff: item.CheckInBasicTariff,
        specialtariff: item.CheckInSpecialTariff,
        amount: item.CheckInAmount,
        Photo: item.Photo,
        Size: item.Size,
        MaxOccupancy: item.MaxOccupancy,
        Bedrooms: item.Bedrooms,
        Balcony: item.Balcony,
        LivingRoom: item.LivingRoom,
        SpaceDetails: item.SpaceDetails,
        AmenitiesDetails: item.AmenitiesDetails,
        SelectedRoomIds: item.SelectedRoomIds,
        total: item.CheckInSpecialTariff,
        CheckInAdditionalAdults: item.CheckInAdditionalAdults,
        CheckInAdditionalChildren: item.CheckInAdditionalChildren,
        CheckInAdditionalCharges: item.CheckInAdditionalCharges,
      }));

    // Step 4: Show popup now, will fill data next
    // handleDeleteRow(0);
    setConfirmRecord2(roomTableDetailsData); // temporary without availableRooms
    setPopupOpen(true);
    // Step 1: Filter child records for this enquiry
    const filteredGuest = Object.values(bindGuestChildData).filter(
      (item) => String(item.TxnEnquiryId) === String(txnEnquiryId)
    );

    // Step 2: Grouping to get unique RoomType
    const groupedTableGuest = {};
    filteredGuest.forEach((item) => {
      const key = item.MstRoomTypeId || item.RoomType;
      if (!groupedTableGuest[key]) {
        groupedTableGuest[key] = item;
      }
    });
    // Step 3: Create base roomTableDetailsData with everything from enquiry child
    const roomTableDetailsDataGuest = Object.values(filteredGuest).map(
      (item) => ({
        TxnEnquiryCheckInChildId: item.TxnEnquiryCheckInChildId,
        TxnEnquiryId: item.TxnEnquiryId,
        TxnEnquiryChildId: item.TxnEnquiryChildId,
        MstRoomTypeId: item.MstRoomTypeId,
        MstRoomId: item.MstRoomId,
        GuestName: item.GuestName,
        Gender: item.Gender, // will be fetched
        Age: item.Age,
        Relationship: item.Relationship,
        IDProofType: item.IDProofType,
        IDProofNumber: item.IDProofNumber,
        Photo: item.Photo,
        CheckOutStatus: item.CheckOutStatus,
      })
    );
    setConfirmRecord3(roomTableDetailsDataGuest);
    // Step 5: Add AvailableRoomsId and AvailableRooms to each row
    const fromDate = toYMD(value.BookFrom); // "2025-08-01"; // or use dynamic: toYMD(value.BookFrom)
    const toDate = toYMD(value.BookTo); //"2025-08-05"; // or use dynamic: toYMD(value.BookTo)

    for (let i = 0; i < roomTableDetailsData.length; i++) {
      const row = roomTableDetailsData[i];
      if (!row.RoomTypeId) continue;

      try {
        const postData = {
          mstRoomTypeId: row.RoomTypeId,
          fromDate: fromDate,
          toDate: toDate,
          mstClientId: clientId,
        };

        const response = await BindPostAPI(
          postData,
          "Enquiry/BindGetRoomDetails"
        );
        const apiRow = response?.data?.Table?.[0];

        if (apiRow) {
          row.AvailableRoomsId = apiRow.AvailableRoomsId ?? "";
          row.AvailableRooms = apiRow.AvailableRooms ?? 0;
          row.AvailableRoomsName = apiRow.AvailableRoomsName ?? "";
        } else {
          row.AvailableRoomsId = "";
          row.AvailableRooms = 0;
        }
      } catch (err) {
        console.error(`RoomTypeId ${row.RoomTypeId} failed:`, err);
        row.AvailableRoomsId = "";
        row.AvailableRooms = 0;
      }
    }

    // Step 6: Push final tableData with AvailableRooms
    setTableData([...roomTableDetailsData]);
    console.log(
      "✅ Final roomTableDetailsData with AvailableRoomsId:",
      roomTableDetailsData
    );

    setConfirmRecord(updatedValue);
    setPopupOpen(true);
  };
  const onViewEnquiry = (rowIndex, flag) => {
    setViewPopUp(true);
    handleEdit(rowIndex, flag);
    setFlag(flag);
  };
  return (
    <MainLayout pageName="3">
      <Loader isVisible={isLoading} size="h-20 w-20" color="border-t-black" blur={true} />
      <div class={mainTable.addScreenTitle}>Check In</div>
      <GridPage
        title="Booking Details"
        header={checkInHeader}
        records={bookedData ?? []}
        blockView={true}
        addView={true}
        onConfirmBooking={onConfirmBooking}
      />
      <GridPage
        title="Check In Details"
        header={checkInHeader1}
        records={bookedData1 ?? []}
        handleEdit={handleEdit}
        handleAction={onViewEnquiry}
        blockView={true}
        addView={true}
        onConfirmBooking={onConfirmBooking}
      />
      <MainPopup popUpOpen={popupOpen} setpopUpOpen={setPopupOpen}>
        <PopUpScreenTitle
          title="Check In"
          hederDetails={true}
          flag={flag}
          setpopUpOpen={setPopupOpen}
        />
        <Checkinpopup
          data={confirm}
          data1={confirm1}
           data2={tableData}
          // data2={confirm2} 
          data3={confirm2}
          data4={confirm3}
          flag={flag}
          ref={childRef}
          setpopUpOpen={setPopupOpen}
          BindGetEnquiryValues={clear}
          isLoading={isLoading}
        />
        <PopUpButtons
          rowIndex={rowIndex}
          handleSubmit={handleClick}
          cancel={cancel}
          hederDetails={true}
          flag={flag}
          // handleUpload={handleClick}
          disabledBtn={submitBtnDisabled}
        />
      </MainPopup>
    </MainLayout>
  );
};

export default CheckIn;
